export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}


// 过滤不需要参数
export function filterData (par = {}) {
  var params = JSON.parse(JSON.stringify(par||{}))
  for (var key in params) {
    if (params[key] === '' || params[key] === undefined || params[key] === null) {
      delete params[key]
    }
  }
  return params
}

// 获取url参数
export function getSearchParams(search) {
  search = search || window.location.search
  const searchParams = {}
  const searchStr = search.substring(1)	// 如果location中有search值，去除search值中的第一个字符‘?’
  const searchArr = searchStr.length ? searchStr.split('&') : [] // 以 & 符为分隔符，解析出key value 组合，组合的形式为'key=value'
  searchArr.forEach(item => {
    const keyAndValue = item.split('=')	// 以 = 为分隔符，解析出key 和 value,其中数组的第一项为key，数组的第二项为value
    const key = decodeURIComponent(keyAndValue[0])    // 如果查询参数中包含中文，会被编码成一串字符串，需要使用decodeURIComponent进行解码
    const value = decodeURIComponent(keyAndValue[1])
    if (key) {
      searchParams[key] = value
    }
  })
  return searchParams
}
//判断当前页面是否是嵌套页面
export function isWebview () {
  const isFrames = (parent.frames.length !== window.frames.length)
  return isFrames && getSearchParams().iframe === '1'
}

